import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import cellPopulation from './cell_population';

export default combineReducers({
  routing: routerReducer,
  cellPopulation,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js